module.exports = __webpack_public_path__ + "static/media/flags_PER.5e3fde64.svg";